import axios from 'axios'
import router from "@/router"
import store from "@/store"
import { decrypt, encrypt } from './crypto'

// ========== 手动切换环境配置 ==========
// 使用哪个就取消注释哪个，注释掉另一个即可

// 本地开发环境（无 /api 前缀）
// const BASE_URL = 'http://localhost:9090'

// 线上生产环境（有 /api 前缀）
const BASE_URL = 'https://geek-coding.cn/api'

// =====================================

console.log('当前使用的 BASE_URL:', BASE_URL)

const request = axios.create({
    baseURL: BASE_URL,
    timeout: 50000000
})

// request 拦截器
// 可以自请求发送前对请求做一些处理
// 比如统一加token，对请求参数统一加密
request.interceptors.request.use(config => {
    // 如果是 FormData，不设置 Content-Type，让浏览器自动设置
    if (!(config.data instanceof FormData)) {
        config.headers['Content-Type'] = 'application/json;charset=utf-8';
    }

    let user = localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : null
    if (user) {
        config.headers['token'] = user.token;  // 设置请求头
    }

    // 对请求参数进行加密（排除文件上传和 GET 请求）
    if (config.data && config.method !== 'get' && !config.skipEncrypt && !(config.data instanceof FormData)) {
        try {
            // 将请求数据转为 JSON 字符串
            const jsonString = typeof config.data === 'string' ? config.data : JSON.stringify(config.data)

            // AES 加密
            const encrypted = encrypt(jsonString)

            // 替换请求数据为加密后的字符串
            config.data = encrypted

            // 添加加密标识请求头
            config.headers['X-Encrypt'] = 'true'

            console.log('✅ 请求参数已加密:', config.url)
        } catch (error) {
            console.error('⚠️ 请求加密失败:', error)
        }
    }

    return config
}, error => {
    return Promise.reject(error)
});

// response 拦截器
// 可以在接口响应后统一处理结果
request.interceptors.response.use(
    response => {
        let res = response.data;

        // 如果是返回的文件（blob），返回完整的 response 对象（包含 headers）
        if (response.config.responseType === 'blob') {
            return response
        }

        // 如果是加密数据（字符串格式），进行解密
        if (typeof res === 'string' && res && !response.config.skipDecrypt) {
            try {
                // 尝试解密
                const decrypted = decrypt(res)
                res = JSON.parse(decrypted)
            } catch (error) {
                try {
                    res = JSON.parse(res)
                } catch (parseError) {
                }
            }
        }

        // 当权限验证不通过的时候给出提示
        if (res && res.code === '401') {
            localStorage.removeItem('user')
            // 触发登录弹窗（不跳转页面）
            store.commit('setShowLoginModal', true)
        }

        return res;
    },
    error => {
        console.log('err' + error) // for debug
        return Promise.reject(error)
    }
)

// 导出 baseURL 供 fetch 流式请求使用
export const baseURL = BASE_URL

// 获取带 token 的 headers（用于 fetch 请求）
export function getHeaders(contentType = 'application/json') {
    const headers = {}
    if (contentType) {
        headers['Content-Type'] = contentType
    }
    const user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null
    if (user && user.token) {
        headers['token'] = user.token
    }
    return headers
}

export default request

